// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2VHHU","title":"ClientReferral_title__14fdA","itemText":"ClientReferral_itemText__1LcAy"};